import React, { createContext, useState, useEffect, useContext } from 'react';
import * as R from 'ramda';
import { noop } from '@cd/utils';

const XPropsStore = createContext({
	onRegisterToken: noop,
	registerRouteCallback: noop
});
const XpropsConsumer = XPropsStore.Consumer;

function XPropsProvider({ children }) {
	const { Provider } = XPropsStore;

	const [xprops, setXProps] = useState(window.xprops);

	useEffect(() => {
		window.xprops &&
			window.xprops.onProps(props => {
				setXProps({ ...props });
			});
	}, []);

	return <Provider value={xprops || XPropsStore}>{children}</Provider>;
}

const useXProps = () => useContext(XPropsStore);

const withXprops = propArr => Cmp => props =>
	(
		<XpropsConsumer>
			{value => {
				return <Cmp {...props} {...R.pick(propArr, value)} />;
			}}
		</XpropsConsumer>
	);

export { XPropsProvider, XPropsStore, XpropsConsumer, withXprops, useXProps };
